import React from 'react';

const iconStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px',
  borderRadius: '8px',
  backgroundColor: '#f3f4f6',
  marginRight: '12px',
  color: '#4b5563'
};

export const AutoplayIcon = (props) => (
  <svg
    height={24}
    viewBox="0 0 24 24"
    width={24}
    id="svg6"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs10" />
    <text
      xmlSpace="preserve"
      style={{
        fontSize: "0.133333px",
        lineHeight: 1.25,
        fontFamily: "Arial",
        letterSpacing: 0,
        wordSpacing: 0,
      }}
      x={7.8726811}
      y={16.112471}
      id="text2833"
    >
      <tspan
        id="tspan2831"
        x={7.8726811}
        y={16.112471}
        style={{
          fontSize: "0.133333px",
        }}
      >
        {"Readerum.com"}
      </tspan>
    </text>
    <path
      style={{
        display: "inline",
        fill: "none",
        stroke: "#000000",
        strokeWidth: "0.688247px",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeOpacity: 1,
      }}
      d="m 12.464459,8.1620763 c 5.488013,0.062247 5.55081,7.8828767 0.563708,7.8942587 -3.5462974,0.0081 -5.2987554,0.0048 -7.638121,-0.01899 C 1.0011733,15.992712 1.0107194,8.2443712 5.2352347,8.2098323 7.4670699,8.1915853 9.9106082,8.1331097 12.464459,8.1620763 Z"
      id="path2002-0"
    />
    <path
      style={{
        display: "inline",
        fill: "#f2f2f2",
        stroke: "#000000",
        strokeWidth: "0.688247px",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeOpacity: 1,
        fillOpacity: 1,
      }}
      d="m 16.854312,6.0463659 c 7.93195,0.022196 8.10172,11.7632271 -0.05501,11.7833451 C 8.6425735,17.84983 9.0633236,6.0245644 16.854312,6.0463659 Z"
      id="path2002"
    />
    <path
      style={{
        display: "inline",
        fill: "#ffffff",
        fillOpacity: 1,
        stroke: "#000000",
        strokeWidth: "0.688247px",
        strokeLinecap: "butt",
        strokeLinejoin: "round",
        strokeOpacity: 1,
        paintOrder: "normal",
      }}
      d="m 14.994534,8.7899293 5.384345,3.2364437 -5.366749,3.184244 z"
      id="path1799"
    />
  </svg>
);
